module.exports = __webpack_public_path__ + "static/media/3d_visualizations.466caab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/3d_visualizations.png
// module id = 210
// module chunks = 0